export default __webpack_public_path__ + "d7ca100605c7a8a20e5cdafe87c23f76.svg";